import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

/**
 * this guard check if you subscribe to the trend area
 */
export const trendGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const user = auth.authToken();
  if (
    user?.groups?.includes('SUBSCRIPTION_ALL') ||
    user?.roles?.includes('SUBSCRIPTION_ALL') ||
    user?.groups?.includes('SUBSCRIPTION_TREND') ||
    user?.roles?.includes('SUBSCRIPTION_TREND')
  ) {
    return true;
  } else {
    router.navigate(['/cockpit/news']);
  }
};
